import { Globals } from "../CoreApp/Globals";

// Decide which view the chart being built should open with. Carry the requested
// (active) view only when it is a promoted view of the chart being built;
// otherwise keep that chart's own default view. This single availability rule is
// doctype-agnostic (plan, Archive, builder). Permission filtering and the final
// fallback are applied centrally in QXDocMgr.LoadiWizData, which validates
// whatever view this seeds. View IDs are string-coerced because they are not
// guaranteed to share a primitive type across the client/server boundary.
export function getBuilderViewId(builderInfo, metadata) {
  const requestedViewId = builderInfo["viewid"];
  const defaultViewId = metadata["svrtemplate"];
  if (requestedViewId == null) return defaultViewId;

  const promotedViews = metadata["views"] ?? [];
  // No promoted-view list to validate against: keep the requested view as-is.
  if (promotedViews.length === 0) return requestedViewId;

  const requestedIsPromoted = promotedViews
    .map(view => String(view))
    .includes(String(requestedViewId));

  return requestedIsPromoted ? requestedViewId : defaultViewId;
}

export function transferBuilderInfo(builderInfo) {
  var metadata = Globals._svrChartMgr["metadata"];
  const resolvedView = getBuilderViewId(builderInfo, metadata);
  metadata["doctype"] = builderInfo["doctype"] || "builder";
  metadata["liveChart"] = builderInfo["liveChart"];
  metadata["chartLevels"] = builderInfo["levels"];
  metadata["chainLevels"] = builderInfo["chainLevels"] || 0;
  metadata["topBoxID"] = builderInfo["topBoxID"];
  metadata["forceTopBoxID"] = builderInfo["forceTopBoxID"];
  metadata["importFilter"] = builderInfo["importFilter"];
  metadata["svrtemplate"] = resolvedView;
  metadata["mtemplate"] = builderInfo["mtemplate"];
}
